module.exports = __webpack_public_path__ + "img/medium-logo.a20a71ca.svg";